import axios from 'axios';
import { API_URL } from '../constants';
export var request = axios.create({
    baseURL: API_URL
});
